/**
 * Default form data for creating a delivery group
 */
export const DEFAULT_FORM_DATA = {
  name: "",
  administrator_id: "",
  type: 0, // 0 = in-house drivers, 1 = delivery companies
  enabled: true,
  drivers: [], // Array of driver IDs (when type = 0)
  driver_companies: [], // Array of driver company IDs (when type = 1)
  business: [], // Array of business IDs
  // Default autoassign values
  autoassign_amount_drivers: 0,
  autoassign_autoaccept_by_driver: false,
  autoassign_autoreject_time: 30,
  autoassign_increment_radius: 100,
  autoassign_initial_radius: 500,
  autoassign_max_in_accepted_by_business: 5,
  autoassign_max_in_accepted_by_driver: 5,
  autoassign_max_in_driver_in_business: 5,
  autoassign_max_in_pending: 5,
  autoassign_max_in_pickup_completed: 5,
  autoassign_max_in_ready_for_pickup: 5,
  autoassign_max_in_driver_on_way: 5,
  autoassign_max_in_driver_almost_arrived_to_customer: 5,
  autoassign_max_orders: 5,
  autoassign_max_radius: 1000,
  orders_group_max_distance_between_delivery: 200,
  orders_group_max_distance_between_pickup: 200,
  orders_group_max_orders: 0,
  orders_group_max_time_between: 5,
  orders_group_max_time_between_delivery: 600,
  orders_group_max_time_between_pickup: 600,
  orders_group_start_in_status: 7,
  orders_group_use_maps_api: false,
  driver_available_max_distance: null,
};

/**
 * Delivery group types
 */
export const DELIVERY_GROUP_TYPES = {
  IN_HOUSE_DRIVERS: 0,
  DELIVERY_COMPANIES: 1,
};

/**
 * Type labels mapping
 */
export const TYPE_LABELS = {
  [DELIVERY_GROUP_TYPES.IN_HOUSE_DRIVERS]: "In-house drivers",
  [DELIVERY_GROUP_TYPES.DELIVERY_COMPANIES]: "Delivery companies",
};

/**
 * Get type label
 * @param {number} type - The type value (0 or 1)
 * @returns {string} The type label
 */
export const getTypeLabel = (type) => {
  return TYPE_LABELS[type] || "Unknown";
};

/**
 * Autoassign and orders group field names
 * These fields are used in delivery group creation and updates
 */
export const AUTOASSIGN_FIELDS = [
  "autoassign_amount_drivers",
  "autoassign_autoaccept_by_driver",
  "autoassign_autoreject_time",
  "autoassign_increment_radius",
  "autoassign_initial_radius",
  "autoassign_max_in_accepted_by_business",
  "autoassign_max_in_accepted_by_driver",
  "autoassign_max_in_driver_in_business",
  "autoassign_max_in_pending",
  "autoassign_max_in_pickup_completed",
  "autoassign_max_in_ready_for_pickup",
  "autoassign_max_in_driver_on_way",
  "autoassign_max_in_driver_almost_arrived_to_customer",
  "autoassign_max_orders",
  "autoassign_max_radius",
  "orders_group_max_distance_between_delivery",
  "orders_group_max_distance_between_pickup",
  "orders_group_max_orders",
  "orders_group_max_time_between",
  "orders_group_max_time_between_delivery",
  "orders_group_max_time_between_pickup",
  "orders_group_start_in_status",
  "orders_group_use_maps_api",
];
